import { PostComposer } from '@tribeplatform/react-components/PostComposer';
export const PostComposerBlock = PostComposer;
//# sourceMappingURL=Block.js.map